import React from "react";
import { RootContext } from "./root-context";
import { usePageRootHook } from "./root-hooks";

export function ContextPageRootProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const value = usePageRootHook();

  return <RootContext.Provider value={value}>{children}</RootContext.Provider>;
}
